import './App.css';
import Home from './pages/home/Home';
import About from './pages/about/About'
import Catalog from './pages/cycle_catalog/Catalog';
import ContactUs from './pages/contactus/ContactUs';
import ComponentCatalog from './pages/component_catalog/ComponentCatalog';
import Bike from './components/Bike/Bike';
import Part from './components/Part/Part';
import BlogsList from './pages/BlogsList/BlogsList';
import Storelocator from './pages/storelocator/storelocator';
import Finance from './pages/finance/finance';
import Service from './pages/service/Service';
import NotFound from './pages/notfound/NotFound';
import Terms from './pages/legal/Terms';
import Privacy from './pages/legal/Privacy';
import RefundPolicy from './pages/legal/RefundPolicy';
import ShippingPolicy from './pages/legal/ShippingPolicy';
import WarrantyReturns from './pages/legal/WarrantyReturns';
import { PaymentSuccess, PaymentFailed } from './pages/payment/PaymentStatus';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/bike_catalog" element={<Catalog />}></Route>
        <Route path="/bike_catalog/:id" element={<Bike />}></Route>
        <Route path="/Part_catalog" element={<ComponentCatalog />}></Route>
        <Route path="/Part_catalog/:id" element={<Part />}></Route>
        <Route path="/contact" element={<ContactUs />}></Route>
        <Route path="/bloglist" element={<BlogsList />}></Route>
        <Route path="/storelocator" element={<Storelocator />}></Route>
        <Route path="/finance" element={<Finance />}></Route>
        <Route path="/service" element={<Service />}></Route>

        {/* Legal / policy pages required for online payment onboarding */}
        <Route path="/terms" element={<Terms />}></Route>
        <Route path="/privacy" element={<Privacy />}></Route>
        <Route path="/refund-policy" element={<RefundPolicy />}></Route>
        <Route path="/shipping-policy" element={<ShippingPolicy />}></Route>
        <Route path="/warranty-returns" element={<WarrantyReturns />}></Route>

        <Route path="/payment-success" element={<PaymentSuccess />}></Route>
        <Route path="/payment-failed" element={<PaymentFailed />}></Route>

        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
